import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { SolutionsGrid, CTA } from "../components/Sections";

export default function Solutions() {
  return (
    <Layout>
      <Seo title="Solutions - ERP, HRMS, CRM & AI Automation" description="Enterprise-grade ERP, HRMS, CRM, AI automation, and cloud solutions by Neuravolt. Custom-built platforms to streamline operations and accelerate growth." keywords="ERP solutions India, HRMS software, CRM development, AI automation solutions, enterprise software, cloud solutions, Neuravolt solutions" path="/solutions" />
      <PageHero eyebrow="Solutions" title="Enterprise platforms, ready to scale" sub="Battle-tested solutions across your entire operation." />
      <SolutionsGrid />
      <CTA />
    </Layout>
  );
}
